import { styled } from '@mui/material';

export const ChatBotWrapperStyled = styled('div')(({ theme }) => ({
  display: 'flex',
  gap: '8px',
  justifyContent: 'right',
  marginRight: '18px',
  [theme.breakpoints.up('lg')]: {
    height: '36px',
    margin: '24px 0 24px 0',
  },
  '& .initial-modal': {
    width: 'auto',
    background: 'none',
    padding: '8px',
    fontSize: '14px',
    backgroundColor: '#ffffff',
    borderRadius: '8px',
    boxShadow: '0px 1px 10px 0px rgba(0, 0, 0, 0.24)',
  },
  '& button': {
    backgroundColor: 'transparent',
  },
}));
